import React from 'react';
import { withRouter } from 'react-router-dom';

import { getSwatchUrl } from './swatch-functions';
import { Helpers } from '../../../core/src/helpers';


/**
 * Component that serializes swatches selection and updates the URL
 * Should also initialize swatch selection for deeplinks to the pdp
 */
class SwatchDeepLink extends React.PureComponent {

    static defaultProps = {
        selectedSwatches: {}
    }

    componentDidUpdate(prevProps, prevState){
        const { swatches, defaultSku, disabledSkus, selectedSwatches, variantsFetched } = this.props;

        //if no select swatches but url contains query, call select product with parsed filter values
        if(Object.keys(selectedSwatches).length === 0 && variantsFetched){
            this.selectProduct()
        }else if(prevProps.selectedSwatches !==  selectedSwatches){
            //else if selectSwatches has changed, update url to reflect deep link query
            this.changeFiltersUrl(selectedSwatches);
        }
    }



    changeFiltersUrl = (selectedSwatches) => {
        const { history, match } = this.props;
        const { params: { basename, dir, slug }} = match;
        
        let location = {pathname: getSwatchUrl(selectedSwatches, `/${basename}`, dir, slug ), search: history.location.search};
        history.replace(location);
    }

    removeFiltersFromUrl = () => {
        const { history, match } = this.props;
        const { params: { basename, dir, slug }} = match;
        let location = {pathname: `/${basename}/${dir}/${slug}`, search: history.location.search};
        history.replace(location);
    }

    parseFilters = Helpers.memoize(
        (filters) => Helpers.parseFilters(filters)
    );

    selectProduct = () => {
        const { disabledSkus, swatches, defaultSku, match: { params: { filters: urlFilters }} } = this.props;
        const filters = this.parseFilters(urlFilters);
        let preSelectedSwatches = {};
		//if filters params exist
		if(filters.hasOwnProperty('query')){
			let i = 0;
			while(i<swatches.length){
				const group = swatches[i];
				preSelectedSwatches[group.key] = group.values.filter((value)=>{
					if(filters.query.hasOwnProperty(group.key)){
						return value.displayName.toLowerCase()  === filters.query[group.key][0];
					}
					return false;
				})[0];
				//if top group preSelection fails
				if(i === 0 && !preSelectedSwatches[group.key]){
					preSelectedSwatches = this.defaultPreselect();
					i = swatches.length;
				}
				//if some other Group preSelection fails
				else if(!preSelectedSwatches[group.key]){
					const prevGroupKey = swatches[i-1].key;
                    const newDefaultProduct = preSelectedSwatches[prevGroupKey].variants.find(variant=>!disabledSkus.includes(variant.sku));
                    let sku;
                    if(newDefaultProduct)sku = newDefaultProduct.sku;
                    else{
                        sku = defaultSku;
                    }
					preSelectedSwatches = this.defaultPreselect(preSelectedSwatches, i, sku, false);
					i = swatches.length;
				}
				else{
					i++;
				}
			}

            //check if selected product was not found or disabled, if yes, then selecting a default product
            const selectedVariant = Object.keys(preSelectedSwatches).reduce((commonVariants, key, index)=>{
                const swatchVariants = preSelectedSwatches[key].variants;
                if(index === 0){
                    commonVariants = swatchVariants;
                }
                else{
                    commonVariants = commonVariants.filter((variant, i) => {
                        const sku = variant.sku;
                        return swatchVariants.some(swatchVariant=>swatchVariant.sku === sku);
                    });
                }
                return commonVariants;
            },[])[0];
            if(!selectedVariant){
                preSelectedSwatches = this.defaultPreselect();
            }
		}else{
			//if no filters provided
			preSelectedSwatches = this.defaultPreselect();
		}
        this.props.selectProduct(preSelectedSwatches);
	}

	defaultPreselect = (preSelectedSwatches={}, index=0, variantSku=this.props.defaultSku, removeFiltersFromUrl=true) => {
        for(let i=index;i<this.props.swatches.length;i++){
			const group = this.props.swatches[i];
			preSelectedSwatches[group.key] = group.values.filter((value)=>
				value.variants.some((variant)=>variant.sku===variantSku)
			)[0];
		}
        if(removeFiltersFromUrl)this.removeFiltersFromUrl();
        else{
            this.changeFiltersUrl(preSelectedSwatches);
        }
		return preSelectedSwatches;
	};

    render(){
        return null;
    }
}
export { SwatchDeepLink };
export default withRouter(SwatchDeepLink);
